import WhishListContainer from "../../Componant/Ecommerce/WhishList";

const WhishList = () => {
  return (
    <div className="page-body">
      <WhishListContainer />
    </div>
  );
};

export default WhishList;
